module.exports = __webpack_public_path__ + "img/k19.19396a62.jpg";